<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Inventory Transfer in (Receipt) 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Transfer not received</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
                <b-col lg="10" >
                <b-input-group>
                    <b-input-group-prepend><label>Receiving Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input>
                    <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
                    <b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input>
                  </b-input-group>
                </b-col>
                <!-- <b-col lg="3">                            
                    <b-input-group>
                        <b-input-group-prepend><label style="width:90px;">Available Qty</label></b-input-group-prepend>
                          <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.openStatus"></b-form-select>
                    </b-input-group>
                </b-col> -->
            </b-row>  
            <b-row>
              <b-col lg="10">
                <b-input-group>
                    <b-input-group-prepend><label>Store/Warehouse</label></b-input-group-prepend>
                    <b-input-group-append><span class="input-group-text">From</span></b-input-group-append>
                    <b-form-select v-model="tblData.idStore" :plain="true" :options="dataList.warehouse"></b-form-select>
                    <b-input-group-append><span class="input-group-text">To</span></b-input-group-append>
                    <b-form-select v-model="tblData.idStoreTo" :plain="true" :options="dataList.warehouse"></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="10">
                <b-input-group>
                    <b-input-group-prepend><label>Transfer Doc. No.</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="Transfer Doc. No."></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
             <b-row>
                <b-col lg="10" >
                  <b-input-group>
                      <b-input-group-prepend><label>Item Category</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.headcategory" placeholder="Head Category"></b-form-input>
                      <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
                      <b-form-input v-model="tblData.nmcategory" placeholder="Category"></b-form-input>
                    </b-input-group>
                  </b-col>
            </b-row>      
            <b-row>
                <b-col lg="10" >
                  <b-input-group>
                    <b-input-group-prepend><label>Item Code/Name</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.transferItem" placeholder="Item Code/Number/Name"></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>    
             
        </b-col>
        <b-col lg="6">
            <b-input-group>
                <b-input-group-prepend><label>Purchase Order#</label></b-input-group-prepend>
                <b-form-input v-model="tblData.purcOrderNo" placeholder="PO Number"></b-form-input>
                <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
                <b-form-input v-model="tblData.vendorinfo" placeholder="Supplier Name"></b-form-input>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
            <b-row>
                <!-- <b-col lg="7" >
                  <b-input-group>
                    <b-input-group-prepend><label>Inspection/GCIF</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.gcifNo" placeholder="Inspection Number"></b-form-input>
                  </b-input-group>
                </b-col> -->
                <b-col lg="5">                            
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
            </b-row>    
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
        show-empty
      >
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(expirDate)="data">
          <span v-if="(data.item.expirDate)">{{data.item.expirDate|moment("DD MMM YYYY")}}</span>
        </template>
        <template v-slot:cell(invUnitCost)="data">
          <span v-if="(data.item.invUnitCost)">{{data.item.invUnitCost|numFormat}}</span>
        </template>
        <template v-slot:cell(qtyTrfOut)="data">
          {{data.item.qtyTrfOut}} &nbsp; {{data.item.invunitom}}
        </template>
        <template v-slot:cell(qtyTrfIn)="data">
          {{data.item.qtyTrfIn || 0}} &nbsp; {{data.item.invunitom}}
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-logistic {
}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import inv from "../../apis/logistic_inv_trf";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,        
        sortBy: 'tanggal',
        sortDesc: true,
        DimCol:'Dim1',postingStatus:'',
        typeTrf:'in',
        idStore:'',
        idStoreTo:'',
      },
      dataList: {
        openStatus: dropdown.ostandStatus,
        warehouse:[],
      },      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Transfer Doc. Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Transfer Date",
            sortable: true
          },
          {
            key: "partnumber",
            thStyle: "width:100px",
            label: "Item Code",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name/Description",
            thStyle: "width:300px",
          },
          {
            key: "typeSeries",
            label: "Model/Type/series",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "serialNum",
            label: "Serial Number",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "expirDate",
            label: "Expired",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "invUnitCost",
            label: "Unit Price",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "qtyTrfOut",
            label: "Qty.Transfer",
            thStyle: "width:100px",
          },
          {
            key: "qtyTrfIn",
            label: "Qty.Received",
            thStyle: "width:100px",
          },
          
          // {
          //   key: "purcOrderNo",
          //   label: "Tranfer Out Doc.#",
          //   thStyle: "width:100px",
          //   sortable: true
          // },
          {
            key: "fromNameStore",
            thStyle: "width:150px",
            label: "From Store/Warehouse",
            sortable: true
          },
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     thStyle: "width:100px",
        //     label: dims[i].text
        //   },)
        // }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
      this.dataList.warehouse = await inv.store(); 
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
   data: async function(ctx) {
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await inv.list(this.tblData);    
      this.items=list;
      this.isLoading=false;
     return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.gcifNo= '';
        this.tblData.nomor= '';
        this.tblData.partnumber=  '';
        this.tblData.purcOrderNo=  '';
        this.tblData.vendorinfo=  '';
        this.tblData.nmcategory='',
        this.tblData.headcategory=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.outstand=  '';
        this.tblData.idStore=  '';
        this.tblData.idStoreTo=  '';
        this.tblData.typeTrf ='out'
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    add(){
      toastr.info("Loading Inventory on Transfer ... ");
      router.push({name :"logistic.transferinfrm"});
    },
    edit: function() {
        if (this.model.invTrfKey) {
          router.push({name :'logistic.transferinfrm', params: { invTrfKey: this.model.invTrfKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.invTrfKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await inv.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.invTrfKey==this.model.invTrfKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.requestkey) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await inv.posting(this.model);
            this.model.posting=1;
            this.print();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await inv.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    print: async function()
    {
      if (this.model.invTrfKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await inv.print(this.model);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await inv.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/logistic/home");
    },    
  }
};
</script>
